import React from 'react'

const AutomationOptionsAdjustAssistantVolume = ({ className }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="38" viewBox="0 0 46 38" fill="none" className={className}>
    <path
      d="M25.3105 12.65C26.9813 14.3209 27.9199 16.5871 27.9199 18.95C27.9199 21.3129 26.9813 23.5791 25.3105 25.25"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M36.9609 1C39.32 3.35622 41.1914 6.15433 42.4683 9.23433C43.7451 12.3143 44.4023 15.6158 44.4023 18.95C44.4023 22.2842 43.7451 25.5857 42.4683 28.6657C41.1914 31.7457 39.32 34.5438 36.9609 36.9"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M31.3301 6.63C32.9495 8.24701 34.2343 10.1674 35.1109 12.2814C35.9874 14.3954 36.4386 16.6615 36.4386 18.95C36.4386 21.2385 35.9874 23.5046 35.1109 25.6186C34.2343 27.7326 32.9495 29.653 31.3301 31.27"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M7.92 10.73H2.86C2.3667 10.73 1.8936 10.926 1.54478 11.2748C1.19596 11.6236 1 12.0967 1 12.59V25.31C1 25.8034 1.19596 26.2765 1.54478 26.6253C1.8936 26.9741 2.3667 27.17 2.86 27.17H7.92C8.54611 27.1686 9.15611 27.3684 9.66 27.74L18.54 34.27C18.7513 34.4222 19.0003 34.5134 19.2599 34.5336C19.5194 34.5538 19.7796 34.5023 20.0118 34.3846C20.2441 34.2669 20.4395 34.0877 20.5768 33.8664C20.714 33.6451 20.7878 33.3904 20.79 33.13V4.77005C20.7878 4.50969 20.714 4.25496 20.5768 4.0337C20.4395 3.81244 20.2441 3.63317 20.0118 3.51549C19.7796 3.39782 19.5194 3.34626 19.2599 3.36646C19.0003 3.38667 18.7513 3.47785 18.54 3.63005L9.7 10.16C9.18514 10.5399 8.55976 10.7402 7.92 10.73V10.73Z"
      stroke="black"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
)

export default AutomationOptionsAdjustAssistantVolume
